import { render, staticRenderFns } from "./OfferItem.vue?vue&type=template&id=0424d3de&scoped=true&"
import script from "./OfferItem.vue?vue&type=script&lang=js&"
export * from "./OfferItem.vue?vue&type=script&lang=js&"
import style0 from "./OfferItem.vue?vue&type=style&index=0&id=0424d3de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0424d3de",
  null
  
)

export default component.exports